import React from 'react';
import Avatar from '@atlaskit/avatar';
import { useFieldValue } from '@atlassian/jira-issue-field-base/src/services/field-value-service/index.tsx';
import { AssigneeKey } from '@atlassian/jira-providers-issue/src/model/issue-system-fields.tsx';
import { useShowAssignee } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { AvatarWrapper } from '../../card/card-contents/assignee-field/assignee-field-static/index.tsx';

export type Props = {
	issueKey: string;
};

export const AssigneeLite = ({ issueKey }: Props) => {
	const showAssignee = useShowAssignee();
	const [assigneeFieldValue] = useFieldValue({
		issueKey,
		fieldKey: AssigneeKey,
	});

	const value = assigneeFieldValue
		? {
				id: assigneeFieldValue.accountId,
				displayName: assigneeFieldValue.displayName,
				avatarUrl: assigneeFieldValue.avatarUrls?.['48x48'],
			}
		: null;

	return showAssignee ? (
		<AvatarWrapper>
			<Avatar src={value?.avatarUrl} size="small" borderColor="transparent" />
		</AvatarWrapper>
	) : null;
};
